import { useFileDownload } from "../components/Common/useFileDownload";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";
import { CustomerActivityReportParams, formatCustomerActivityReportQuery } from "./useGetCustomerActivityReport";

export const useDownloadCustomerActivityReport = (params: CustomerActivityReportParams) => {
  const business = useSelectedBusiness();

  return useFileDownload(formatCustomerActivityReportQuery(business.id, params, true), 'customerActivityReport.csv');
}